import {useMemo} from 'react';

import {buildCompanyMatchesListFilterQueryString} from '../features/company/recruiting/matches/companyMatchesListFilters';
import {GetRoutes} from '../lib/api/GET/GetRoutes';
import {CompanyMatchesSummaryResponse} from '../types/shared-recruiting-types';

import {useApiRead} from './useApiRead';

export const MATCHES_SUMMARY_QUERY_KEY = 'matches-summary';

export const useMatchesSummary = (
  companyId: string | undefined,
  jobCsv: string | undefined,
  statusCsv: string | undefined
) => {
  const path = useMemo(() => {
    if (!companyId) {
      return '';
    }
    const qs = buildCompanyMatchesListFilterQueryString(jobCsv, statusCsv);
    const base = GetRoutes.companyMatchesSummary(companyId);
    return qs ? `${base}?${qs}` : base;
  }, [companyId, jobCsv, statusCsv]);

  return useApiRead<CompanyMatchesSummaryResponse>({
    path,
    options: {
      enabled: Boolean(companyId),
      queryKey: [MATCHES_SUMMARY_QUERY_KEY, companyId, jobCsv, statusCsv],
    },
  });
};
